import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { isWhatWeOfferActiveSelector, tenantSocialsSelector } from '../../../../customer/redux/common/common.selectors';
import { SocialLinksComponent } from './social-links';
const mapStateToProps = createStructuredSelector({
  socials: tenantSocialsSelector,
  isWhatWeOfferActive: isWhatWeOfferActiveSelector
});
export const SocialLinks = connect(mapStateToProps)(SocialLinksComponent);